module.exports = __webpack_public_path__ + "static/media/power.aeb5f347.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/power.svg
// module id = 294
// module chunks = 0